export enum TypeOfMember {
  USER = "User",
  STAFF = "Staff",
}

export enum MemberCertificationStatus {
  APPROVED = "Approved",
  WAITING = "Waiting approval",
}

export enum MemberAvailabilityType {
  ABSENCE = "Absence",
  ILLNESS = "Illness",
  TRAINING = "Training",
}

export enum MembersGender {
  MALE = "Male",
  FEMALE = "Female",
  NOT_BINARY = "Not Binary",
  OTHER = "Other",
}

export enum MemberAvailabilityStatus {
  IN_PROGRESS = "In progress",
  CANCELLED = "Cancelled",
  COMPLETED = "Completed",
}

export enum TimesheetOptions {
  MOCK_OPTION = "mockOption",
  EXISTENT_OPTION = "existsOption",
}
